// Author Lin
// Date 2021-11-19 16:46:45

class MintalMesMstWarehouse {
    constructor({
            id = null,
            locationId = '',
            locationName = '',
            code = '',
            warehouseName = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.locationId = locationId;
        this.locationName = locationName;
        this.code = code;
        this.warehouseName = warehouseName;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesMstWarehouse();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.mst.mintalMesMstWarehouse.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'locationId',
            label: 'label.mintal.mst.mintalMesMstWarehouse.grid.locationId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'locationName',
            label: 'label.mintal.mst.mintalMesMstWarehouse.grid.locationName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'code',
            label: 'label.mintal.mst.mintalMesMstWarehouse.grid.code',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.mst.mintalMesMstWarehouse.grid.warehouseName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.mst.mintalMesMstWarehouse.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        locationIdFilter : '',
        locationNameFilter : '',
        codeFilter : '',
        warehouseNameFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'locationNameFilter',
            label: 'label.mintal.mst.mintalMesMstWarehouse.filter.locationName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'imfMstLocation'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                    }
            },
            {
            key: 'codeFilter',
            label: 'label.mintal.mst.mintalMesMstWarehouse.filter.code',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'warehouseNameFilter',
            label: 'label.mintal.mst.mintalMesMstWarehouse.filter.warehouseName',
            disabled: false,
            form: {
            type: 'input'
                    }
            }
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'locationName',
            label: 'label.mintal.mst.mintalMesMstWarehouse.entity.locationName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'imfMstLocation'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                    }
            },
            {
            key: 'code',
            label: 'label.mintal.mst.mintalMesMstWarehouse.entity.code',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.mst.mintalMesMstWarehouse.entity.warehouseName',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.mst.mintalMesMstWarehouse.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesMstWarehouse, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    